import { createSlice } from '@reduxjs/toolkit';

export interface SnackbarState {
  isOpen: boolean;
  message: string;
  severity: 'success' | 'warning' | 'error' | 'info';
}

const initialState: SnackbarState = {
  isOpen: false,
  message: '',
  severity: 'info',
};

export const alertSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    setSnackbar: (state, action) => {
      state.severity = action.payload.severity;
      state.message = action.payload.message;
      state.isOpen = true;
    },
    closeSnackbar: (state) => {
      state.isOpen = false;
    },
  },
});

export const { setSnackbar, closeSnackbar } = alertSlice.actions;

export default alertSlice.reducer;
